import React, { useEffect } from 'react';
import useApp from '../../hooks/useApp';
import useUserEKS from '../../hooks/useUserEKS';
import { MaxTries } from '../../modules/setup';

const UpdateApp: React.FC = () => {
  const { tries, updatedOn, isFetching, updateCtx } = useApp();

  const { language, userId } = useUserEKS();
  const { setLanguage, setStoreUser } = useApp();

  useEffect(() => {
    setLanguage(language || '');
  }, [language]);

  useEffect(() => {
    if (userId) setStoreUser(userId);
  }, [userId]);

  useEffect(() => {
    if (tries < MaxTries && !updatedOn && !isFetching) updateCtx();
  }, [updatedOn, tries, isFetching]);

  return <></>;
};

export default UpdateApp;
